import { ChangeDetectionStrategy, Component } from "@angular/core";
import { StringHelper } from "../../../utilities/contracts/string-helper";
import { DynamicControlComponent } from "../../dynamic-control-component.model";
import { Switch } from "./switch.model";

@Component({
  selector: "form-switch",
  templateUrl: "./switch.component.html",
  styleUrls: ["./switch.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwitchComponent extends DynamicControlComponent<Switch> {

  get hasSubLabel(): boolean {
    return StringHelper.isAvailable(this.model.subLabel);
  }

  get hasPreceedingOffLabel(): boolean {
    return StringHelper.isAvailable(this.model.preceedingOffLabel);
  }

  get hasFollowingOnLabel(): boolean {
    return StringHelper.isAvailable(this.model.followingOnLabel);
  }

  get classes(): string {
    return this.getClasses("switch");
  }

}
